import React from "react";
import Card from "./Card";
import {
  PiNumberCircleOneFill,
  PiNumberCircleTwoFill,
  PiNumberCircleThreeFill,
} from "react-icons/pi";

import { SiGoogledocs } from "react-icons/si";
import { IoLocationOutline } from "react-icons/io5";
import { IoMdTime } from "react-icons/io";
import { MdOutlineGroups } from "react-icons/md";
import { IoCheckbox } from "react-icons/io5";
import { FaPenSquare } from "react-icons/fa";

const CareCircle = () => {
  const cards = [
    {
      title: "My Role",
      content:
        "As the UX Designer, I led the end-to-end design process for the healthcare app, from research and user flows to wireframing and prototyping. My role involved creating intuitive user experiences, designing seamless interfaces, and ensuring the app met the needs of user’s of all age groups.",
      bgColor: "bg-h-color",
      textColor: "text-white",
    },
    {
      title: "Key Deliverables",
      content:
        "Conducting interviews, paper and digital wireframing, low and high-fidelity prototyping, conducting usability studies, accounting for accessibility, iterating on designs and responsive design.",
      bgColor: "bg-cy",
      textColor: "text-black",
    },
    {
      title: "The Problem",
      content:
        "Complicated and non-intuitive scheduling systems often leave users frustrated and discouraged from managing their healthcare proactively. CareCircle focuses on usability and an inviting interface to eliminate confusion and make booking doctor appointments straightforward and pleasant.",
      bgColor: "bg-cy",
      textColor: "text-black",
    },
    {
      title: "My Goals",
      content:
        "Designing CareCircle, my main objective is to develop an app that combines intuitive navigation with an effective user interface. This approach emphasizes usability and provides an easy-to-use platform that caters to the needs of diverse user groups, particularly older individuals, to enhance the overall user experience.",
      bgColor: "bg-h-color",
      textColor: "text-white",
    },
  ];
  return (
    <>
      <div className="container mx-auto py-10  px-10">
        <div className="grid grid-cols-2 gap-2">
          <div className="justify-items-center content-center">
            <div className="text-left lg:w-4/12 ml-10">
            <h1>Case Study:</h1>
            </div>
            <h1 className="text-h-color  text-3xl">
              CareCircle: <br />
              Healthcare <br />
              Scheduling App
            </h1>
          </div>
          <div className="bg-cy justify-items-center py-12">
            <img
              src="/assets/img/carecircle/carecirceapp.png"
              className="w-6/12"
              alt=""
            />
          </div>
        </div>
      </div>

      <section className="px-10 pt-10 ">
        <div className="container mx-auto">
          <div className="justify-items-center text-center">
            <h1 className="text-2xl font-bold text-h-color border-b-2 border-h-color pb-3 w-full  ">
              Project Overview
            </h1>
          </div>

          <div>
            <h1 className="text-h-color text-2xl font-bold mt-20 mb-5">
              CareCircle: Healthcare Scheduling App
            </h1>
            <p className="text-justify text-lg">
              CareCircle is a healthcare scheduling app that blends an
              easy-to-use, intuitive design with usability-focused features.
              Designed to reduce the complexity of booking appointments, it
              ensures users can manage their healthcare effortlessly, supported
              by a calming user interface. It caters to users of all age group,
              creating a stress-free scheduling process.
            </p>
          </div>

          <div className="bg-cy rounded-xl shadow-md  mt-10 pt-10 ">
            <div className="justify-items-center items-center">
              <img
                src="/assets/img/carecircle/app3-in-11.png"
                className="lg:w-6/12 md:w-5/12 sm:w-4/12"
                alt=""
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-5 mt-20">
            {cards.map((card, index) => (
              <Card
                key={index}
                title={card.title}
                content={card.content}
                bgColor={card.bgColor}
                textColor={card.textColor}
              />
            ))}
          </div>
          <div className="mt-20 px-5 justify-items-center">
            <img src="/assets/img/carecircle/probleam.png" alt="" />
          </div>

          <div class="flex items-center justify-center py-20">
            <div class="grid grid-cols-2 w-3/4">
              {/* <!-- Left Column --> */}
              <div class="text-left h-96 content-center justify-items-end">
                <h1 class="lg:text-2xl font-semibold text-h-color  text-right pr-10  ">
                  Understanding <br />
                  The User
                </h1>
              </div>
              {/* <!-- Right Column --> */}
              <div class="border-l-2 border-black h-96 content-center  pl-10">
                <ul class="list-disc space-y-2 text-gray-800">
                  <li>User Research</li>
                  <li>Persona</li>
                  <li>Pain Points</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="py-10">
            <h1 className="text-2xl font-bold">User Research</h1>
            <p className="text-justify mt-5 ">
              For the CareCircle healthcare scheduling app project, I conducted
              comprehensive user research by creating detailed user personas,
              mapping user journeys, defining a clear goal statement, and
              designing user flows. The user personas provided insight into
              different user groups, including older adults who value
              simplicity. User journeys outlined each step in booking
              appointments, highlighting pain points and opportunities for a
              smoother process. The goal statement emphasized making scheduling
              doctor visits easy and intuitive for all. User flows were designed
              to enhance navigation and ensure a seamless, user-friendly
              experience from initial login to appointment confirmation.
            </p>
          </div>

          <div className="py-10 ">
            <h1 className="text-2xl font-bold">User Persona</h1>
            <div className=" px-5 py-10 justify-items-center">
              <img
                src="/assets/img/carecircle/user.png"
                className="w-6/12"
                alt=""
              />
            </div>
          </div>
          <div className="py-10 ">
            <h1 className="text-2xl font-bold">User Pain Point</h1>
          </div>

         
          <div className="py-10 px-5 md:px-10 lg:px-20">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10">
              {/* Card 1 */}
              <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  <PiNumberCircleOneFill className="text-6xl text-red-600" />
                </div>
                <h1 className="text-xl md:text-2xl font-bold">
                  Complex Navigation and User Interface
                </h1>
                <p className="text-justify mt-4">
                  Many healthcare apps have cluttered interfaces and complex
                  navigation systems, making them difficult to use, especially
                  for older adults or those with limited tech literacy.
                </p>
              </div>

              {/* Card 2 */}
              <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  <PiNumberCircleTwoFill className="text-6xl text-red-600" />
                </div>
                <h1 className="text-xl md:text-2xl font-bold">
                  Poor User <br /> Experience
                </h1>
                <p className="text-justify mt-4">
                  Lack of intuitive design and user-friendly features can lead
                  to frustration and dissatisfaction among users, particularly
                  when dealing with health-related concerns.
                </p>
              </div>

              {/* Card 3 */}
              <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
                <div className="flex justify-center mb-4">
                  <PiNumberCircleThreeFill className="text-6xl text-red-600" />
                </div>
                <h1 className="text-xl md:text-2xl font-bold">
                  Insufficient Appointment Scheduling
                </h1>
                <p className="text-justify mt-4">
                  Existing apps often have time-consuming and inefficient
                  appointment scheduling processes, requiring users to navigate
                  multiple screens and fill out lengthy forms.
                </p>
              </div>
            </div>
          </div>

          <div class="flex items-center justify-center py-20">
            <div class="grid grid-cols-2 w-3/4">
              {/* <!-- Left Column --> */}
              <div class="text-left h-96 content-center justify-items-end">
                <h1 class="text-2xl font-semibold text-h-color  text-right pr-10  ">
                  Starting the <br /> Design Process
                </h1>
              </div>
              {/* <!-- Right Column --> */}
              <div class="border-l-2 border-black h-96 content-center  pl-10">
                <ul class="list-disc space-y-2 text-gray-800">
                  <li>Sitemap</li>
                  <li>Paper Wireframes</li>
                  <li>Digital Wireframes</li>
                  <li>Low Fidelity Prototype</li>
                  <li>Usability Studies</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="pt-10 ">
            <h1 className="text-2xl font-bold">Sitemap</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/carecircle/sitemap.png"
                className="text-center  lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Paper Wireframes</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/carecircle/paperwire.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Digital Wireframes</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/carecircle/wireframe.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Low-Fidelity Prototype</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/carecircle/LowFidelity.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold text-yellow-300">
              Usability Study:Parameters
            </h1>
            <div className="py-10 lg:px-60">
              <div className="grid grid-cols-2 gap-5">
                <div className="border-2 rounded-xl   text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center my-5">
                    <SiGoogledocs className="text-5xl lg:text-7xl text-yellow-300" />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Study type:</h1>
                  <p className=" mt-5">Moderated Usability study</p>
                </div>
                <div className="border-2 rounded-xl    text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center my-5">
                    <IoLocationOutline className="text-5xl lg:text-7xl text-yellow-300 " />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Location:</h1>
                  <p className=" mt-5">India</p>
                </div>
                <div className="border-2 rounded-xl   text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center">
                    <MdOutlineGroups className="text-5xl lg:text-7xl text-yellow-300" />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Participants</h1>
                  <p className=" mt-5">5 participants</p>
                </div>
                <div className="border-2 rounded-xl  text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center">
                    <IoMdTime className="text-5xl lg:text-7xl text-yellow-300 " />
                  </div>

                  <h1 className="lg:text-2xl font-bold  ">Length:</h1>
                  <p className=" mt-5">20-30 mintues</p>
                </div>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-red-600">
              Usability Study:Findings
            </h1>
            
            <div className="py-10 px-5 md:px-20 ">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {/* Card 1 */}
                <div className="border-2 rounded-xl text-center px-6 py-10 bg-white shadow-md hover:shadow-lg transition-shadow">
                  <div className="mb-5">
                    <PiNumberCircleOneFill className="text-6xl text-red-600 mx-auto" />
                  </div>
                  <h1 className="text-xl md:text-2xl font-bold">Reschedule</h1>
                  <p className="text-justify mt-4">
                    Users couldn’t find the option to reschedule an appointment.
                  </p>
                </div>

                {/* Card 2 */}
                <div className="border-2 rounded-xl text-center px-6 py-10 bg-white shadow-md hover:shadow-lg transition-shadow">
                  <div className="mb-5">
                    <PiNumberCircleTwoFill className="text-6xl text-red-600 mx-auto" />
                  </div>
                  <h1 className="text-xl md:text-2xl font-bold">
                    Appointment Type
                  </h1>
                  <p className="text-justify mt-4">
                    Users noted difficulty understanding the appointment type
                    options (e.g., in-person, video call) due to unclear icons
                    and lack of descriptive labels, making it hard to select the
                    correct type.
                  </p>
                </div>

                {/* Card 3 */}
                <div className="border-2 rounded-xl text-center px-6 py-10 bg-white shadow-md hover:shadow-lg transition-shadow">
                  <div className="mb-5">
                    <PiNumberCircleThreeFill className="text-6xl text-red-600 mx-auto" />
                  </div>
                  <h1 className="text-xl md:text-2xl font-bold">Homepage</h1>
                  <p className="text-justify mt-4">
                    Users mentioned that a section of “explore medical
                    specialist” should be on the homepage for quick actions.
                  </p>
                </div>
              </div>
            </div>

            <div class="flex items-center justify-center py-20">
              <div class="grid grid-cols-2 w-3/4">
                {/* <!-- Left Column --> */}
                <div class="text-left h-96 content-center justify-items-end">
                  <h1 class="text-2xl font-semibold text-h-color  text-right pr-10  ">
                    Refining the <br /> Design
                  </h1>
                </div>
                {/* <!-- Right Column --> */}
                <div class="border-l-2 border-black h-96 content-center  pl-10">
                  <ul class="list-disc space-y-2 text-gray-800">
                    <li>Mockups</li>
                    <li>Hi-Fi Prototype</li>
                    <li>Accessibilty</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="pt-10">
              <h1 className="text-2xl font-bold">Mockups</h1>
              <p className="text-justify mt-5 ">
                Based on the insights from the usability study, I made changes
                to improve the app’s checkout flow. One of the changes I made
                was that i added a button to reschedule an appointment.
              </p>
              <div className="lg:flex justify-around pt-10 relative ">
                <img
                  src="/assets/img/carecircle/mockups.png"
                  className="my-2"
                  alt=""
                />
                <img
                  src="/assets/img/carecircle/mockups-2.png"
                  className="my-2"
                  alt=""
                />
              </div>
              <div>
                <p className="py-10">
                  To make the scheduling process easier for users i added icons
                  to the appointment type options. This allow users to easily
                  understand appointment types.
                </p>
              </div>
              <div className="lg:flex justify-around pt-10 ">
                <img
                  src="/assets/img/carecircle/mockups-3.png"
                  className="my-2"
                  alt=""
                />
                <img
                  src="/assets/img/carecircle/mockups-4.png"
                  className="my-2"
                  alt=""
                />
              </div>
              <div className="py-10">
                <h1 className="text-2xl font-bold">High Fidelity Prototype </h1>
                <p className="text-justify my-5 ">
                  My hi-fi prototype followed the same user flow as the lo-fi
                  prototype, and included the design changes made after the
                  usability study, as well as several changes suggested by
                  members of my team. Link to the hi-fi prototype-
                </p>
                <div className="">
                  <a
                    className="border-2 border-h-color hover:bg-h-color hover:text-white  px-8 py-1 rounded-lg"
                    href="https://www.figma.com/proto/1WParhtW94jZV0FbzEHCO4?node-id=20-38&t=3cHuGm37rJigqpq1-6&fuid=1354767664026663772"
                  >
                    Hi-Fi Link
                  </a>
                </div>
                <div className="justify-items-center mt-5">
                  <img
                    src="/assets/img/carecircle/hi-fi.png"
                    className="lg:w-6/12"
                    alt=""
                  />
                </div>
              </div>

              <div className="py-10">
                <h1 className="text-2xl font-bold">
                  Accessibility Considerations{" "}
                </h1>

                
                <div className="py-10">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {/* Card 1 */}
                    <div className="text-center px-6 py-10 bg-gray-100 relative">
                      {/* Icon */}
                      <div className="absolute top-5 left-1/2 transform -translate-x-1/2">
                        <PiNumberCircleOneFill className="text-6xl text-btncolor" />
                      </div>
                      {/* Content */}
                      <p className="text-justify mt-20">
                        I used headings with different sized text for clear
                        visual hierarchy.
                      </p>
                    </div>

                    {/* Card 2 */}
                    <div className="text-center px-6 py-10 bg-gray-100 relative">
                      {/* Icon */}
                      <div className="absolute top-5 left-1/2 transform -translate-x-1/2">
                        <PiNumberCircleTwoFill className="text-6xl text-btncolor" />
                      </div>
                      {/* Content */}
                      <p className="text-justify mt-20">
                        Intuitive and straightforward navigation structures were
                        implemented, featuring large, touch-friendly buttons and
                        clearly labeled elements.
                      </p>
                    </div>

                    {/* Card 3 */}
                    <div className="text-center px-6 py-10 bg-gray-100 relative">
                      {/* Icon */}
                      <div className="absolute top-5 left-1/2 transform -translate-x-1/2">
                        <PiNumberCircleThreeFill className="text-6xl text-btncolor" />
                      </div>
                      {/* Content */}
                      <p className="text-justify mt-20">
                        I used contrasting colours for call-to-action buttons to
                        help users with low vision.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex items-center justify-center py-20">
                <div class="grid grid-cols-2 w-3/4">
                  {/* <!-- Left Column --> */}
                  <div class="text-left h-96 content-center justify-items-end">
                    <h1 class="text-2xl font-semibold text-h-color  text-right pr-10  ">
                      Going Forward
                    </h1>
                  </div>
                  {/* <!-- Right Column --> */}
                  <div class="border-l-2 border-black h-96 content-center  pl-10">
                    <ul class="list-disc space-y-2 text-gray-800">
                      <li>Takeaways </li>
                      <li>Next Steps</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="py-10">
                <h1 className="text-2xl font-bold text-h-color">Takeaways</h1>
                <div className=" mt-10 grid lg:grid-cols-2 gap-20">
                  <div>
                    <div>
                      <IoCheckbox className="text-red-900 text-7xl" />
                    </div>

                    <h1 className="text-2xl font-bold py-5">Impact:</h1>
                    <p className="text-justify">
                      Designing CareCircle allowed me to create an app that
                      empowers users to easily book and manage doctor
                      appointments. The intuitive, user-friendly design received
                      positive feedback, especially from older users.
                      Accessibility features enhanced the overall experience,
                      promoting confidence and ease.
                    </p>
                  </div>
                  <div>
                    <div className="text-red-900 text-7xl">
                      <SiGoogledocs />
                    </div>
                    <h1 className="text-2xl font-bold py-5">What I Learned:</h1>
                    <p className="text-justify">
                      {" "}
                      I gained valuable insights into empathy-driven design for
                      diverse users, including seniors and those with varying
                      tech skills. Usability testing emphasized the importance
                      of clear navigation and accessible touchpoints. This
                      project reinforced my commitment to creating simple,
                      effective, and inclusive user experiences.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-10">
                <h1 className="text-2xl font-bold text-h-color">
                  Lets Connect
                </h1>
                
                <div className="mt-20 lg:mt-10">
                  <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-6 sm:px-10 relative">
                    {/* Icon */}
                    <div className="absolute top-[-3rem] lg:top-[-4rem] left-1/2 transform -translate-x-1/2">
                      <FaPenSquare className="text-7xl sm:text-8xl text-red-900" />
                    </div>

                    {/* Content */}
                    <div className="text-center">
                      <p className="text-gray-700">
                        Thank you for reviewing my work on the CareCircle:
                        Healthcare Scheduling App. If you’d like to see more or
                        get in touch, my contact information is provided below:
                      </p>
                      <p className="py-5 text-gray-800">
                        <span className="font-bold">Email: </span>
                        <a
                          href="mailto:nainajoshi6126@gmail.com"
                          className="hover:underline text-blue-600"
                        >
                          nainajoshi6126@gmail.com
                        </a>
                      </p>
                      <p className="text-gray-800">
                        <span className="font-bold">LinkedIn:</span>{" "}
                        <a
                          href="https://www.linkedin.com/in/naina-joshi-960863333/"
                          className="hover:underline text-blue-600"
                        >
                          LinkedIn Profile
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareCircle;
